import type {
  TLastRentThisVisit,
  TMajorActionDoubleTheRentData,
} from '@kapitalist/contract/types'
import type {TMillions} from '@kapitalist/contract/types/millions'
import {show$} from '@kapitalist/contract/utils/millions/copy'
import {skins} from '~/game/skins'
import {DoubleTheRentCard} from '~/models/game/Cards/ActionCard'
import {PlayerGamePosition} from '~/models/game/GamePosition'
import type {TMajorActionUserFacingDescriptionData} from '~/models/game/MajorAction'
import MajorActionRentBase from '~/models/game/MajorActions/MajorActionRentBase'
import type Portfolio from '~/models/game/Portfolio'
import type StandardPortfolioNeighborhood from '~/models/game/PortfolioNeighborhoods/StandardPortfolioNeighborhood'
import {standardPNForIdThrows} from '~/models/game/utils'

// weirdly, we replace everything from TMajorActionDoubleTheRentData here :P
// and this can't be EmptyObject because we can't `implements` that, so I just commented it out for now
// type PublicMembersFromApi = {}

export default class MajorActionDoubleTheRent extends MajorActionRentBase<TMajorActionDoubleTheRentData> {
  /* implements PublicMembersFromApi */ card: DoubleTheRentCard
  // which neighborhood was used to initiate the rent
  portfolioNeighborhood: StandardPortfolioNeighborhood

  lastRentThisVisit: TLastRentThisVisit
  millionsOwed: TMillions

  constructor(
    data: TMajorActionDoubleTheRentData,
    portfolio: Portfolio,
    lastRentThisVisit: TLastRentThisVisit
  ) {
    super(data)
    this.card = new DoubleTheRentCard(data.card)
    this.lastRentThisVisit = lastRentThisVisit
    this.portfolioNeighborhood = standardPNForIdThrows(portfolio)(
      data.portfolioNeighborhoodId
    )
    this.millionsOwed = lastRentThisVisit.originalRentAction.millionsOwed
  }

  public userFacingDescription({
    tense,
    skin,
    gamePosition,
  }: TMajorActionUserFacingDescriptionData): string {
    const currentPlayer =
      gamePosition instanceof PlayerGamePosition
        ? gamePosition.currentPlayer
        : undefined
    const majorActor = gamePosition.majorActorPlayer
    const dropFirstNoun = tense === 'imperativePrompt'

    const originalRent = this.lastRentThisVisit.originalRentAction

    return skins[skin].gameLogDescriptions.majorActions.doubleTheRent({
      tense,
      actor: dropFirstNoun
        ? undefined
        : currentPlayer?.id === majorActor.id
          ? 'You'
          : majorActor.username,
      hitVerb: dropFirstNoun ? 'Hit' : 'hit',
      target:
        originalRent.type === 'directionalRent'
          ? gamePosition.players.find(o => o.id === originalRent.minorActorPlayerId)
              ?.username
          : 'everyone',
      cardName: this.card.displayName(skin),
      color: this.portfolioNeighborhood.displayColorShort(skin),
      amount: show$(this.millionsOwed),
    })
  }
}
